'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _moment = require('moment');var _moment2 = _interopRequireDefault(_moment);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);

var _components = require('../../components');

var _constants = require('../../constants');

var _SavedSearchesList = require('./SavedSearchesList.scss');var styles = _interopRequireWildcard(_SavedSearchesList);
var _formatSavedSearchData = require('../../utils/formatSavedSearchData');var _formatSavedSearchData2 = _interopRequireDefault(_formatSavedSearchData);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Helpers
// Styles
var SavedSearchesList = function (_Component) {_inherits(SavedSearchesList, _Component);function SavedSearchesList() {var _temp, _this, _ret;_classCallCheck(this, SavedSearchesList);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.





    setTitlesWidth = function (targetContainer, exampleContainer) {
      targetContainer.style.width = exampleContainer.clientWidth + 'px';

      for (var idx = 0; idx < targetContainer.children.length; idx += 1) {
        var targetElement = targetContainer.children[idx];
        var exampleElement = exampleContainer.children[idx];

        targetElement.style.width = exampleElement.clientWidth + 'px';
      }
    }, _this.

    getInnerRef = function (ref) {
      _this.contentRef = ref;
    }, _this.

    formatAddress = function (address) {
      var result = '';

      if (address.street_name) {
        var houseNumber = address.house_number ? ' ' + address.house_number + ', ' : ', ';
        result += '' + address.street_name + houseNumber;
      }

      result += address.city_name || '';
      return result;
    }, _this.

    constructFilters = function (data) {var _this$props =
      _this.props,locale = _this$props.locale,translate = _this$props.translate;
      return (0, _formatSavedSearchData2.default)(data, locale, translate);
    }, _this.

    renderList = function () {return _this.props.savedSearches && _this.props.savedSearches.map(function (search, idx) {
        var CellComponent = _this.props.isMobile ? _components.SavedSearchesCellMobile : _components.SavedSearchesCell;var
        id = search.id,createdAt = search.createdAt,name = search.name,smartAgentId = search.smartAgentId,smartAgentIsActive = search.smartAgentIsActive;
        var createdDate = (0, _moment2.default)(createdAt).format('DD/MM/YYYY');
        var address = (0, _get2.default)(search, 'locationSearch[' + _this.props.locale + ']') ||
        (0, _get2.default)(search, 'locationSearch[' + _constants.language.fallback + ']') || {};

        return (
          _react2.default.createElement(CellComponent, {
            getInnerRef: !idx ? _this.getInnerRef : undefined,
            key: id,
            translate: _this.props.translate,
            createdAt: createdDate,
            email: search.email,
            address: _this.formatAddress(address),
            name: name,
            filters: _this.constructFilters(search),
            search: search,
            showResults: function showResults(evt) {
              evt.stopPropagation();
              _this.props.applySearch(search);
            },
            toggleSmartAgentState: function toggleSmartAgentState() {
              _this.props.toggleSmartAgentState(smartAgentId, !smartAgentIsActive, id);
            },
            removeSearch: function removeSearch(evt) {
              evt.stopPropagation();
              _this.props.removeSearch(id, smartAgentId);
            } }));


      });}, _temp), _possibleConstructorReturn(_this, _ret);}SavedSearchesList.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState, snapshot) {if (this.props.titlesRef && this.contentRef && this.props.savedSearches && this.props.savedSearches.length) {this.setTitlesWidth(this.props.titlesRef, this.contentRef);}};SavedSearchesList.prototype.

  render = function render() {
    return (
      _react2.default.createElement('div', { className: styles.searchesList },
        this.renderList()));


  };return SavedSearchesList;}(_react.Component);exports.default = SavedSearchesList;


SavedSearchesList.propTypes = {
  titlesRef: _propTypes2.default.object,
  isMobile: _propTypes2.default.bool,
  locale: _propTypes2.default.string,
  savedSearches: _propTypes2.default.array,
  translate: _propTypes2.default.func,
  applySearch: _propTypes2.default.func,
  toggleSmartAgentState: _propTypes2.default.func,
  removeSearch: _propTypes2.default.func };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SavedSearchesList/SavedSearchesList.js
// module id = 2917
// module chunks = 0